module.exports = __webpack_public_path__ + "img/call-dis.eae67d26.png";